//When changing this file, also adjust backend/src/data/hazardFactors.ts

export const HAZARD_FACTORS = [
  {
    number: 1,
    icon: "mdi-sitemap",
    title: "Grundlegende organisatorische Faktoren",
    color: "#c0392b",
    points: [
      { code: "1.1", label: "Arbeitsplätze: Unterweisung" },
      { code: "1.2", label: "Arbeitsplätze: Betriebsanweisung" },
      { code: "1.3", label: "Koordinieren von Arbeiten" },
      { code: "1.4", label: "Gefährliche Arbeiten" },
      { code: "1.5", label: "Benutzen persönlicher Schutzausrüstungen" },
      { code: "1.6", label: "Erste-Hilfe-Systeme" },
      { code: "1.7", label: "Alarm- und Rettungsmaßnahmen" },
      { code: "1.8", label: "Hygiene" },
      { code: "1.9", label: "Arbeitsschutzorganisation, Managementsysteme" },
      { code: "1.10", label: "Allgemeine Kommunikation" },
      { code: "1.11", label: "Prüfpflichten von Arbeitsmitteln und Anlagen" },
      { code: "1.12", label: "Besonders schutzbedürftige Personengruppen" },
    ],
  },
  {
    number: 2,
    icon: "mdi-stairs",
    title: "Gefährdung durch Arbeitsplatzgestaltung",
    color: "#e59866",
    points: [
      { code: "2.1", label: "Arbeitsräume" },
      { code: "2.2", label: "Verkehrswege" },
      {
        code: "2.3",
        label: "Sturz auf der Ebene, Ausrutschen, Stolpern, Umknicken, Fehltreten",
      },
      { code: "2.4", label: "Absturz" },
      { code: "2.5", label: "Behälter, Silos und enge Räume" },
      { code: "2.6", label: "Arbeiten am Wasser" },
    ],
  },
  {
    number: 3,
    icon: "mdi-weight-lifter",
    title: "Gefährdung durch ergonomische Faktoren",
    color: "#f1c40f",
    points: [
      { code: "3.1", label: "Schwere körperliche Arbeit" },
      { code: "3.2", label: "Einseitig belastende körperliche Arbeit" },
      { code: "3.3", label: "Beleuchtung" },
      { code: "3.4", label: "Klima" },
      { code: "3.5", label: "Informationsaufnahme" },
      { code: "3.6", label: "Wahrnehmungsumfang" },
      { code: "3.7", label: "Erschwerte Handhabbarkeit von Arbeitsmitteln" },
      { code: "3.8", label: "Sitzarbeitsplätze" },
      { code: "3.9", label: "Bildschirmarbeitsplätze" },
    ],
  },
  {
    number: 4,
    icon: "mdi-cog",
    title: "Mechanische Gefährdung",
    color: "#7dbb6f",
    points: [
      { code: "4.1", label: "Ungeschützte bewegte Maschinenteile" },
      { code: "4.2", label: "Teile mit gefährlichen Oberflächen" },
      { code: "4.3", label: "Transportmittel" },
      { code: "4.4", label: "Unkontrolliert bewegte Teile" },
    ],
  },
  {
    number: 5,
    icon: "mdi-flash",
    title: "Elektrische Gefährdung",
    color: "#aed6f1",
    points: [
      { code: "5.1", label: "Grundsätze" },
      { code: "5.2", label: "Gefährliche Körperdurchströmung" },
      { code: "5.3", label: "Lichtbögen" },
      { code: "5.4", label: "Elektromagnetische Felder" },
    ],
  },
  {
    number: 6,
    icon: "mdi-flask",
    title: "Gefährdung durch Stoffe",
    color: "#d98880",
    points: [
      {
        code: "6.1",
        label:
          "Gesundheitsschädliche Wirkung von Gasen, Dämpfen, Aerosolen, Stäuben, Flüssigkeiten und festen Stoffen",
      },
      { code: "6.2", label: "Hautbelastungen" },
      {
        code: "6.3",
        label:
          "Sonstige Einwirkungen und gefährliche Wechselwirkung infolge von Stoffeinwirkungen",
      },
    ],
  },
  {
    number: 7,
    icon: "mdi-fire",
    title: "Gefährdung durch Brände/Explosionen",
    color: "#f7dc6f",
    points: [
      { code: "7.1", label: "Brandgefahr durch Feststoffe, Flüssigkeiten, Gase" },
      { code: "7.2", label: "Gefahren durch explosionsfähige Gemische" },
      { code: "7.3", label: "Thermische Explosionen (durchgehende Reaktionen)" },
      { code: "7.4", label: "Physikalische Explosionen und Siedeverzüge" },
      { code: "7.5", label: "Explosivstoffe (Sprengstoffe)" },
      {
        code: "7.6",
        label: "Sonstige explosionsgefährliche Stoffe (z. B. Peroxide)",
      },
    ],
  },
  {
    number: 8,
    icon: "mdi-biohazard",
    title: "Biologische Gefährdung",
    color: "#45b39d",
    points: [
      { code: "8.1", label: "Gezielte Tätigkeiten" },
      { code: "8.2", label: "Nicht gezielte Tätigkeiten" },
      { code: "8.3", label: "Infektionsgefährdung bei Epidemie/Pandemie" },
    ],
  },
  {
    number: 9,
    icon: "mdi-volume-high",
    title: "Gefährdung durch spezielle physikalische Einwirkungen",
    color: "#3498db",
    points: [
      { code: "9.1", label: "Lärm" },
      { code: "9.2", label: "Ultraschall" },
      { code: "9.3", label: "Ganzkörperschwingungen" },
      { code: "9.4", label: "Hand-Arm-Schwingungen" },
      { code: "9.5", label: "Nicht ionisierende (optische) Strahlung" },
      { code: "9.6", label: "Ionisierende Strahlung" },
      { code: "9.7", label: "Elektromagnetische Felder (siehe Abschnitt 5)" },
      { code: "9.8", label: "Heiße und kalte Medien; Kälte-/Hitzearbeit" },
      { code: "9.9", label: "Elektrostatik" },
      { code: "9.10", label: "Überdruck/Unterdruck" },
    ],
  },
  {
    number: 10,
    icon: "mdi-head-cog",
    title: "Gefährdung durch psychische Belastung",
    color: "#a3c4bc",
    points: [
      { code: "10.1", label: "Arbeitsinhalt/Arbeitsaufgabe" },
      { code: "10.2", label: "Arbeitsorganisation" },
      { code: "10.3", label: "Arbeitszeit" },
      { code: "10.4", label: "Soziale Beziehungen" },
      { code: "10.5", label: "Arbeitsmittel" },
      { code: "10.6", label: "Arbeitsumgebung" },
    ],
  },
  {
    number: 11,
    icon: "mdi-dots-horizontal-circle",
    title: "Sonstige Gefährdungen und Belastungen",
    color: "#a569bd",
    points: [
      { code: "11.1", label: "Reise-, Fahr- und Steuertätigkeit" },
      { code: "11.2", label: "Menschen" },
      { code: "11.3", label: "Tiere" },
      { code: "11.4", label: "Pflanzen" },
    ],
  },
];

export const STOP_MEASURE_TYPES = [
  { value: "S", label: "Substitution" },
  { value: "T", label: "Technisch" },
  { value: "O", label: "Organisatorisch" },
  { value: "P", label: "Persönlich" },
];

export function hazardFactorByNumber(number) {
  return HAZARD_FACTORS.find((f) => f.number === Number(number));
}

export const STOP_KEYS = ["S", "T", "O", "P"];

function hasStopContent(entry) {
  return !!(
    String((entry && entry.text) || "").trim() ||
    String((entry && entry.action) || "").trim() ||
    String((entry && entry.measurement) || "").trim()
  );
}

export function stopHasContent(entry) {
  return hasStopContent(entry);
}

export function stopMeasuresOf(risk) {
  const out = {};
  for (const key of STOP_KEYS) out[key] = { text: "", action: "", measurement: "" };
  const incoming = risk && risk.stopMeasures;
  if (incoming && STOP_KEYS.some((key) => hasStopContent(incoming[key]))) {
    for (const key of STOP_KEYS) {
      const entry = incoming[key] || {};
      out[key] = {
        text: entry.text || "",
        action: entry.action || "",
        measurement: entry.measurement || "",
      };
    }
    return out;
  }
  const legacy = {
    text: (risk && risk.measureTypeText) || "",
    action: (risk && risk.action) || "",
    measurement: (risk && risk.measurement) || "",
  };
  if (hasStopContent(legacy)) {
    const key = STOP_KEYS.includes(risk && risk.measureType)
      ? risk.measureType
      : "S";
    out[key] = legacy;
  }
  return out;
}

export function factorsOfRisk(risk) {
  const list =
    risk && Array.isArray(risk.hazardFactors) && risk.hazardFactors.length
      ? risk.hazardFactors
      : risk && risk.hazardFactor
      ? [risk.hazardFactor]
      : [];
  return [...new Set(list.map(Number))].sort((a, b) => a - b);
}
